import { subscribe } from '../common/errors/sagas';
import { notificationError } from '../common/errors/notificationTypes';

const pre = 'AUTH';

export const GET_USER_PERMISSIONS_REQUEST = `${pre}/GET_USER_PERMISSIONS_REQUEST`;
export const GET_USER_PERMISSIONS_SUCCESS = `${pre}/GET_USER_PERMISSIONS_SUCCESS`;
export const GET_USER_PERMISSIONS_ERROR = `${pre}/GET_USER_PERMISSIONS_ERROR`;

subscribe(GET_USER_PERMISSIONS_ERROR, 'Failed to fetch the list of Permissions', notificationError);

export const getUserPermissionsRequest = () => ({
    type: GET_USER_PERMISSIONS_REQUEST
});

export const getUserPermissionsSuccess = response => ({
    type: GET_USER_PERMISSIONS_SUCCESS,
    response
});

export const getUserPermissionsError = message => ({
    type: GET_USER_PERMISSIONS_ERROR,
    message
});
